var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-filter"},[_c('v-autocomplete',{attrs:{"items":_vm.items,"item-value":"merchantId","item-text":"merchantName","outlined":"","dense":"","label":"Merchants"},on:{"change":_vm.merchantSelected},model:{value:(_vm.merchant),callback:function ($$v) {_vm.merchant=$$v},expression:"merchant"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }